import { LocalURL, LoginURL, URLKpostLogin } from './URL'



export async function getCountrylist() {
  try {
    const response = await fetch(`${URLKpostLogin}/common/countries`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 201) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function LoginKpostAPI(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/getCompanyDetails`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function FetchKpostId(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/signupLogin/fetchUserDetails`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function LoginKpost(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/signupLogin/userLogin`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export const postalPincode = async (body) => {
  console.log(body, 'testsce')
  try {
    const response = await fetch(`${URLKpostLogin}/common/postalPinCode`, {
      method: `post`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (e) {
    throw e
  }
}

// Forget Password

export async function ForgetPasswordSentOTP(body) {
  try {
    const response = await fetch(`${LoginURL}/admin/forgot-password/otp`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function ForgetPasswordOTPVerify(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/validateOTP`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function ForgetPasswordUpdate(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/forgotPasswordUpdate`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}
export async function LoginAPI(body) {
  try {
    const response = await fetch(
      `${LoginURL}/user/login`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function FetcUserData(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/fetch-data`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function LoginByKPOSTID(body) {
  try {
    const response = await fetch(`${LoginURL}/admin/login`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500 || response.status === 401 || response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}




export async function getCountryList() {
  try {
    const response = await fetch(`${LoginURL}/countries/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function createCompanyList(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/companies/add`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function UpdateCompanylist(body, companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/companies/update/${companyId}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function GetCompanylist() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/companies/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetCompanyByIdlist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/companies/${companyId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function Getspecialityist() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function SaveCompanySpeciality(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/map-company`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function GetInvoicelist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/companies/invoice/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetCompanyMappingList(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/map-company/${companyId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function uploadpfdtoApi(body) {
  const token = JSON.parse(localStorage.getItem("accessToken"));

  try {
    const response = await fetch(`${LoginURL}/assets/cf/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: body,
    });

    const data = await response.json();

    // Return response data for all expected status codes
    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return data;
    }

    // Handle unexpected status codes
    throw new Error(data?.error || "Something went wrong");

  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
}

export const ChangePasswordAPI = async (body) => {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/admin/change-password`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function uploadLogoToApi(body) {
    const token = JSON.parse(localStorage.getItem("accessToken"));

  try {
    const response = await fetch(`${LoginURL}/assets/stream/image-list`, {
       headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "POST",
      body: body,
    });

    const data = await response.json();

    if (response.status === 200 || response.status === 201) {
      return data;
    }
    else if (
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return data;
    }
    else {
      throw new Error(data?.error || "Something went wrong");
    }

  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
}




export async function SaveAdvertisement(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetAdvertisementlist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetUserlist(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function JournalAdminUser(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function DeleteAdvertisement(advertisementId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/${advertisementId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export const DeleteCompanySpeciality = async (mappingId) => {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/specialities/map-company/${mappingId}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetUserDetailsList(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/user/get?companyId=${companyId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function DeleteUserList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/user/block-status/${userId}/true`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function DeleteAdminList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/block-status/${userId}/true`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}
export async function DeleteCompanyList(companyID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/companies/block-status/${companyID}/true`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function ActivateUserList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/user/block-status/${userId}/false`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}



export async function ActivateCompanyList(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/companies/block-status/${companyId}/false`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}






export async function ActivateAdminList(userId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/admin/block-status/${userId}/false`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function Updateavertisement(body, id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/advertisements/update/${id}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetSpecialityUserDetailsList(companyId, specialityId = null) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'));

    // Build URL — append specialityId only if provided
    const url = specialityId
      ? `${LoginURL}/user/get?companyId=${companyId}&specialityId=${specialityId}`
      : `${LoginURL}/user/get?companyId=${companyId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json();
    } else {
      const errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (error) {
    console.error('API Error:', error?.response || error.message);
  }
}


export async function AddPrice(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/speciality-pricing/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function Addcompanyinvoicelist(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/companies/invoice/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function GetPrice() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/speciality-pricing/get`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function UpdatePrice(body, specialityId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/speciality-pricing/update/${specialityId}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}


export async function AddJournalAdvertisement(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/journal/advertisement/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function GetJournalAdvertisementList() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/journal/advertisement`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

// ── Advertisement organisations (Journal Advertisement) — Super Admin only ──
async function journalCompanyRequest(path, method, body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisement-organisations${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export const createJournalCompany = (body) => journalCompanyRequest('/add', 'POST', body)
export const UpdateJournalCompany = (body, companyId) =>
  journalCompanyRequest(`/update/${companyId}`, 'PATCH', body)
export const GetJournalCompanylist = () => journalCompanyRequest('/getAll', 'GET')
export const GetJournalCompanyById = (companyId) => journalCompanyRequest(`/${companyId}`, 'GET')
export const DeleteJournalCompany = (companyId) =>
  journalCompanyRequest(`/block-status/${companyId}/true`, 'PATCH')
export const ActivateJournalCompany = (companyId) =>
  journalCompanyRequest(`/block-status/${companyId}/false`, 'PATCH')

// All advertisements as shown on the public website (every organisation, in display order)
export async function GetPublicAdvertisements() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    // const response = await fetch(`${LoginURL}/public/advertisements`, {
    // const response = await fetch(`${LoginURL}/advertisements/getAll`, {
    const response = await fetch(`${LoginURL}/advertisements/website/getAll`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

// ── Advertisement invoices (Journal Invoice Generation) ──
async function advertisementInvoiceRequest(path, method, body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisement-invoices${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export const CreateAdvertisementInvoice = (body) => advertisementInvoiceRequest('/add', 'POST', body)
export const GetAdvertisementInvoices = () => advertisementInvoiceRequest('/getAll', 'GET')
export const GetAdvertisementInvoiceById = (invoiceId) =>
  advertisementInvoiceRequest(`/${invoiceId}`, 'GET')
export const CancelAdvertisementInvoice = (invoiceId) =>
  advertisementInvoiceRequest(`/cancel/${invoiceId}`, 'PATCH')

// ── Kadjournal's own advertisements ──
async function kadjournalAdRequest(path, method, body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${LoginURL}/advertisements/kadjournal${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    if ([200, 201, 400, 401, 403, 404, 409, 500].includes(response.status)) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export const AddKadjournalAdvertisements = (body) => kadjournalAdRequest('/add', 'POST', body)
export const GetKadjournalAdvertisements = () => kadjournalAdRequest('/getAll', 'GET')
export const GetKadjournalAdvertisementById = (id) => kadjournalAdRequest(`/${id}`, 'GET')
export const UpdateKadjournalAdvertisement = (body, id) =>
  kadjournalAdRequest(`/update/${id}`, 'PATCH', body)
export const BlockKadjournalAdvertisement = (id, block) =>
  kadjournalAdRequest(`/block-status/${id}/${block}`, 'PATCH')
export const DeleteKadjournalAdvertisement = (id) => kadjournalAdRequest(`/${id}`, 'DELETE')
